import { useEffect, useState } from "react";
import { useCompanyContext } from "./use-company-context";
import { useCompany } from "./use-company";

export const useCheckCompanyWaitingPayment = () => {
  const { leUuid } = useCompanyContext();
  const [isWaitingPayment, setIsWaitingPayment] = useState<boolean>(false);
  const { companyDetailQuery } = useCompany();
  const { data: companyDetails, isPending: companyIsLoading } = companyDetailQuery(leUuid);

  useEffect(() => {
    const userValidation = !!companyDetails?.legalEntity?.UserValidation;
    const paymentDue = companyDetails?.legalEntity?.PaymentDueAmount ?? 0;

    setIsWaitingPayment(userValidation && paymentDue > 0);
  }, [companyDetails]);

  return { isWaitingPayment, isLoading: companyIsLoading };
};
